import React, { Component } from 'react';
import BasePage from './BasePage';
import Session from '../services/session'
import Banner from '../partials/Banner';
import i from '../imports';
import c from '../components';

import BreadCrumbs from '../partials/BreadCrumbs';


class BlogPage extends Component {

    constructor(props) {
        super(props);
    }
   

    render() {

        let galleryPictures = this.props.data.blogImages ? this.props.data.blogImages.map(i => `${i.pic}`) : [];

        return (
                <BasePage data={this.props.data}>
                    <BreadCrumbs fullpath={window.location.pathname} name={this.props.data.title} md={8}/> 
                    <i.Container>
                        <i.Row justify= 'center' style={{paddingBottom:10, paddingTop:20}}>
                            <i.Col md={6} >
                                <c.Gallery images={galleryPictures} />
                            </i.Col>
                            <i.Col md={2} className="content-text" style={{ fontSize: '12pt',  fontStyle: 'italic', textAlign: "justify" }} >
                                {i.markdown(this.props.data.short_description)}
                            </i.Col>
                        </i.Row>
                        <i.Row justify= 'center' style={{paddingBottom:20}}>
                            <i.Col md={8} align="left" className="content-text"  style={{textAlign: "justify" }}>
                                {i.markdown(this.props.data.__content)}
                            </i.Col>
                        </i.Row>
                    </i.Container>
                </BasePage>
        );
    }
}

export default BlogPage;